// double check if the sizing is ok for responsiveness
function Hero() {
  return (
    <div className="ml-[12px] desktop:mt-0 desktop:ml-[28px] tablet:ml-[20px]">
      <h1 className="font-murmure pointer-events-none opacity-[.13] fixed top-[70px] text-aboutmob desktop:text-about desktop:mt-9 tablet:mt-[100px] tablet:text-[200px]">
        ABOUT
        <span className="hidden desktop:hidden min-[1411px]:inline min-[950px]:inline">
          &nbsp;TOUCHPOINT
        </span>
      </h1>
      <div className="h-[200px] tablet:h-[300px] desktop:h-[360px]"></div>
      <div className=" font-apfelgrotezk desktop:mt-[140px] tablet:mt-[80px]">
        <p className="text-paboutmob w-[296px] desktop:text-pabout desktop:w-[1020px] tablet:text-paboutt tablet:w-[560px]">
          Touchpoint is an annual design conference for Vancouver’s aspiring
          creatives, unpacking professional approaches and insights about the
          industry.&nbsp;
          <div className="h-[11px] visible tablet:hidden"></div>
          <span className="opacity-[.5] block tablet:inline">
            Hosted by SFU’s School of Interactive Arts + Technology, Touchpoint
            2023 will be held on March 18 at the university’s&nbsp;
            <a
              href="https://goo.gl/maps/rUvxwV1v1rtGGbDz8"
              className="underline-offset-3 underline decoration-1"
              target="_blank"
              rel="noreferrer"
            >
              SYRE Building
              <span className="tablet:hidden">
                &nbsp;(10285 University Dr, Surrey, BC)
              </span>
              .
            </a>
          </span>
        </p>
        <a
          href="mailto:touchpointconferences@gmail.com"
          className="font-apfelgrotezk mt-[19px] text-paboutmob
                    desktop:text-pabout desktop:mt-[117px] inline-block tablet:text-paboutt tablet:mt-[55px]"
        >
          **touchpointconferences@gmail.com
        </a>
      </div>
    </div>
  );
}

export default Hero;
